import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BatchRecoveryOptionsModel} from "../../models/batch-recovery-options.model";

@Injectable({providedIn: 'root'})
export class BatchRecoveryHttpService {

  private base_url: string = `/batch/v2`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getRecoveryOptions(batchId: string): Observable<BatchRecoveryOptionsModel> {
    return this.http
      .get<BatchRecoveryOptionsModel>(`${this.base_url}/${batchId}/recovery/options`);
  }

  retry(batchId: string): Observable<void> {
    return this.http
      .post<void>(`${this.base_url}/${batchId}/recovery/retry`, null);
  }

  skip(batchId: string): Observable<void> {
    return this.http
      .post<void>(`${this.base_url}/${batchId}/recovery/skip`, null);
  }

  cancel(batchId: string): Observable<void> {
    return this.http
      .post<void>(`${this.base_url}/${batchId}/recovery/cancel`, null);
  }
}
